import { render } from "./MachineQueue.vue?vue&type=template&id=8541832e&scoped=true"
import script from "./MachineQueue.vue?vue&type=script&lang=js"
export * from "./MachineQueue.vue?vue&type=script&lang=js"

import "./MachineQueue.vue?vue&type=style&index=0&id=8541832e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8541832e"]])

export default __exports__